import { yupResolver } from "@hookform/resolvers/yup";
import React, { useEffect, useState } from "react";
import { useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useOutletContext } from "react-router";
import {
  getDomainNamesActionHandler,
  isLoginIdExistsActionHandler,
} from "../../../../store/actions/actionHandlers/adminActionHandler/userManagementActionHandler";
import { userManagementForm } from "../../../../utils/mainTabs/admin/userManagement/userManagementForm";
import { addUserDetailsSchema } from "../../../../utils/mainTabs/admin/userManagement/userManagementFormSchema";
import Button from "../../../Common/Button/Button";
import Input from "../../../Common/Input/Input";
import classes from "./AddUserDetails.module.scss";
import { FormattedMessage } from "react-intl";
import { isVisible } from "@testing-library/user-event/dist/utils";

const AddUserDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const {
    userLocationPath,
    formValues,
    setFormValues,
    editUserPath,
    aadRadio,
    customRadio,
    setCustomRadio,
  } = useOutletContext();
  const [isLoginIdExists, setIsLoginIdExists] = useState(false);
  const [isValidLoginId, setIsValidLoginId] = useState(true);
  const [fields, setFields] = useState([]);
  const [unregisterDomainName, setUnregisterDomainName] = useState(false);

  const commonState = useSelector((state) => state.commonReducer);
  const { myProfile } = commonState;
  const adminStateReducer = useSelector((state) => state.adminReducer);
  const { userManagementReducer } = adminStateReducer;
  const { isLoginIdExistsLoader } = userManagementReducer;
  const methods = useForm({
    resolver: yupResolver(addUserDetailsSchema),
    defaultValues: { ...formValues },
    mode: "onChange",
  });
  const {
    handleSubmit,
    formState: { errors, isDirty, isValid },
    reset,
    register,
    unregister,
    setValue,
    watch,
  } = methods;

  useEffect(() => {
    reset(formValues);
  }, [formValues, reset]);

  const {
    userDetails: { formFields },
  } = userManagementForm;
  const tenanatType = localStorage
    .getItem("SecurityProviderName")
    .toLowerCase();
  const tenantData = JSON.parse(localStorage.getItem("tenantData") || "{}");
  const isHybridIdentityTenant =
    tenantData?.SAMLConfig?.IdentityType === 2 &&
    ["saml2", "custom"].includes(tenanatType);
  const domainNameValue = watch("DomainName");
  const handleNameExists = useCallback(
    (e) => {
      let val = e.target.value.trim() !== "" && e.target.value.trim();
      if (tenanatType == "aad") {
        if (val) {
          if (/^[a-zA-Z0-9._]*$/.test(val)) {
            setIsValidLoginId(true);
            dispatch(
              isLoginIdExistsActionHandler(
                val + "" + domainNameValue?.[0]?.Name
              )
            ).then((response) => {
              setIsLoginIdExists(response);
            });
          } else {
            setIsValidLoginId(false);
          }
        } else {
          setIsValidLoginId(true);
          setIsLoginIdExists(false);
        }
      } else {
        if (val) {
          if (/^[a-zA-Z0-9-._@\]\[ ]*$/.test(val)) {
            setIsValidLoginId(true);
            dispatch(isLoginIdExistsActionHandler(val)).then((response) => {
              setIsLoginIdExists(response);
            });
          } else {
            setIsValidLoginId(false);
          }
        } else {
          setIsValidLoginId(true);
          setIsLoginIdExists(false);
        }
      }
    },
    [
      dispatch,
      setIsLoginIdExists,
      setIsValidLoginId,
      domainNameValue,
      tenanatType,
    ]
  );
  const [domainNameList, setDomainNameList] = useState([]);
  const [editPath, setEditPath] = useState(false);
  useEffect(() => {
    const isDisabled = location.pathname.includes(editUserPath);
    const fieldsList = formFields(
      handleNameExists,
      isLoginIdExistsLoader,
      isDisabled,
      domainNameList,
      setDomainNameList,
      editPath,
      customRadio
      // handleSelectDomainName,
      // formArgs
    );
    setFields(fieldsList);
  }, [
    formFields,
    handleNameExists,
    isLoginIdExistsLoader,
    location.pathname,
    editUserPath,
    domainNameList,
    setDomainNameList,
    editPath,
    setEditPath,
    customRadio,
    setCustomRadio,
    unregisterDomainName,
    setUnregisterDomainName,
  ]);
  useEffect(() => {
    if (location.pathname.includes(editUserPath)) setEditPath(true);
  }, [editUserPath, setEditPath]);

  const onSubmit = (data) => {
    setFormValues({ ...formValues, ...data });
    navigate(userLocationPath);
  };

  useEffect(() => {
    if (tenanatType == "saml2" || isHybridIdentityTenant) {
      dispatch(getDomainNamesActionHandler()).then((response) => {
        if (response.data) {
          let setDomainName = response?.data?.map((item) => {
            return { ...item, Name: "@" + item.Name, isVisible: true };
          });
          setDomainNameList(setDomainName);
        }
      });
    } else {
      // const a = unregister("DomainName", { required: true })
      // console.log(a)
    }
    // else if (tenanatType === "aad") {
    //   let domainName = myProfile?.LoginId?.split("@");
    //   let obj = [{ Id: myProfile?.ID, Name: domainName?.[1], isVisible: true }];
    //   setDomainNameList(obj);
    // }
  }, [dispatch, isHybridIdentityTenant, tenanatType]);
  useEffect(() => {
    if (customRadio) {
      const a = delete formValues?.DomainName;
      // setUnregisterDomainName(true);
    } else {
      // setUnregisterDomainName(false);
    }
  }, [customRadio, tenanatType, setUnregisterDomainName]);
  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.addUserDetails__form}
      >
        <div className={classes.addUserDetails__form__fields}>
          {fields
            .filter((item) => item?.isVisible)
            .map((field) => {
              let loginIdError =
                !isValidLoginId && tenanatType == "aad"
                  ? "Only alphanumeric, special char(.,_)"
                  : !isValidLoginId && tenanatType !== "aad"
                  ? "Only alphanumeric, special char(._@-)"
                  : "Sorry, this login id is already used";
              let isLoginIdError =
                field?.name === "LoginId" &&
                (isLoginIdExists || !isValidLoginId);
              return (
                <div
                  className={classes.addUserDetails__form__fields__field}
                  key={field?.key}
                >
                  <Input
                    key={field?.key}
                    label={field?.label}
                    name={field?.name}
                    type={field?.type}
                    fieldName={field?.fieldName}
                    fieldValue={field?.fieldValue}
                    placeholder={field?.placeholder}
                    height={field?.height}
                    width={field?.width}
                    labelColor={field?.labelColor}
                    labelMsg={field?.labelMsg}
                    maxLength={field?.maxLength}
                    error={
                      isLoginIdError
                        ? loginIdError
                        : errors?.[field?.name]?.message
                    }
                    required={field?.required}
                    onChange={field?.onChange}
                    loading={field?.loading}
                    disabled={field?.disabled}
                    searchTagsList={field?.searchTagsList}
                    handleTagList={field?.handleTagList}
                    isTagCheckBoxVisible={false}
                    tagType="single"
                    addedTagsVisible={false}
                    buttonLabel={field?.buttonLabel}
                    display={field?.isVisible}
                    // searchable={field?.searchable}
                  />
                </div>
              );
            })}
        </div>
        <div className={classes.addUserDetails__form__footer}>
          {(isDirty || isValid) && (
            <div
              className={classes.addUserDetails__form__footer__clearAll}
              onClick={() => reset()}
            >
              <FormattedMessage id="CLEAR_ALL_TXT" />
            </div>
          )}
          <Button
            label={"Save & Next"}
            small
            dark
            type="submit"
            disabled={
              !isValid || !isValidLoginId ||
              isLoginIdExists ||
              ((tenanatType === "saml2" || isHybridIdentityTenant) &&
                domainNameValue?.length === 0 &&
                !customRadio) ||
              (isHybridIdentityTenant &&
                !(aadRadio || customRadio) &&
                !editPath)
            }
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default AddUserDetails;
